export function normalizeAutopaymentStatus(status) {
  if (!status) {
    return null;
  }

  const value = String(status).trim().toLowerCase();

  if (['active', 'available', 'disabled'].includes(value)) {
    return value;
  }

  if (value === 'inactive') {
    return 'disabled';
  }

  if (value === 'enabled') {
    return 'active';
  }

  return null;
}

export function resolveAutopaymentStatus(primary, fallback, defaultValue = null) {
  return normalizeAutopaymentStatus(primary) ?? normalizeAutopaymentStatus(fallback) ?? defaultValue;
}
